module.exports = __webpack_public_path__ + "static/media/tests.9e988ccb.jpg";